import React, { useEffect, useState } from 'react';
import { useIsMobile, useIsSmallTablet } from 'hooks/use-size-class';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import DownArrowIcon from 'components/icon/down-arrow-icon';

export default function JoinExpUSHeroFr({ downArrowRef }: { downArrowRef: React.RefObject<HTMLDivElement> }) {
  const [activeIndices, setActiveIndices] = useState<number[]>([]);
  const isMobile = useIsMobile();
  const isTablet = useIsSmallTablet();
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  const onArrowClick = () => {
    if (downArrowRef.current) {
      downArrowRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsPageLoaded(true);
    }, 500);
  }, []);

  useEffect(() => {
    let intervalId: number | undefined;
    if (isMobile || isTablet) {
      intervalId = window.setInterval(() => {
        const randomIndex = Math.floor(Math.random() * 13);
        setActiveIndices([randomIndex]);
      }, 2000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isMobile, isTablet]);

  return (
    <div className={styles.component} data-testid="HeroFR">
      <div className={styles['video-container']}>
        <video autoPlay muted loop>
          <source src="/next/assets/videos/join-expus/join-expus-hero-video.mp4" type="video/mp4" />
        </video>
      </div>
      <div className={styles['content-container']}>
        <h1 className={isPageLoaded ? styles.visible : ''}>
          <span className={buildClassName(styles.J, activeIndices.includes(0) ? styles.activeLetter : '')}>R</span>
          <span className={activeIndices.includes(1) ? styles.activeLetter : ''}>E</span>
          <span className={activeIndices.includes(2) ? styles.activeLetter : ''}>J</span>
          <span className={activeIndices.includes(3) ? styles.activeLetter : ''}>O</span>
          <span className={activeIndices.includes(4) ? styles.activeLetter : ''}>I</span>
          <span className={activeIndices.includes(5) ? styles.activeLetter : ''}>G</span>
          <span className={activeIndices.includes(6) ? styles.activeLetter : ''}>N</span>
          <span className={activeIndices.includes(7) ? styles.activeLetter : ''}>E</span>
          <span className={activeIndices.includes(8) ? styles.activeLetter : ''}>Z</span>
          <span> </span>
          <span className={buildClassName(styles.U, activeIndices.includes(9) ? styles.activeLetter : '')}>N</span>
          <span className={activeIndices.includes(10) ? styles.activeLetter : ''}>O</span>
          <span className={activeIndices.includes(11) ? styles.activeLetter : ''}>U</span>
          <span className={activeIndices.includes(12) ? styles.activeLetter : ''}>S</span>
        </h1>
        <a className={styles['down-arrow-container']}>
          <DownArrowIcon className={styles['down-arrow']} onClick={onArrowClick} />
        </a>
        <div className={styles['hero-quote-container']}>
          <p>Là où les <span className={styles.bold}>pros</span> </p>
          <p><span className={styles.bold}>avancent</span></p>
        </div>
      </div>
    </div>
  );
}
